import { useAuth } from '@/features/auth/hooks/useAuth';
import { useAuthorization } from '@/features/auth/context/AuthorizationContext';

export function usePermission() {
  const { user } = useAuth();
  const authorization = useAuthorization();

  return {
    user,
    ...authorization,
  };
}
